<template>
  <v-row>
    <v-col cols="12" class="px-0">
      <v-toolbar color="transparent" flat height="48">
        <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
          <router-link :to="{ name: 'Components' }" class="subtitle-1 routerLink font-weight-medium">Componentes</router-link> <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon> Links
        </v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="4" v-if="$store.state.apps.retrieveLoader">
      <v-skeleton-loader type="article" />
    </v-col>

    <!-- feature landing page -->
    <template v-else-if="linksList && linksList.length === 0">
      <v-col cols="12">
        <v-sheet class="component-hero" rounded="lg">
          <v-row class="pt-6 pl-6" align="start" justify="center">
            <v-col cols="7">
              <v-avatar color="white" size="48">
                <img :src="require('@/assets/appIcon-apps--PaymentLinks.svg')" style="width:28px;height:28px;border-radius:0;" />
              </v-avatar>
              <span class="d-block mt-2 text-h5 text--secondary font-weight-medium">Crea y envía enlaces de pago en segundos</span>
              <span class="d-block mt-2 body-1 text--secondary font-weight-regular">Simplifica tus cobros con los enlaces de pago de Piriod. Genera enlaces personalizados en segundos y comienza a recibir pagos sin integraciones complejas.</span>
              <v-btn class="mt-14" :to="{name: 'LinkCreate'}" color="primary">Comenzar</v-btn>
            </v-col>
            <v-col cols="5" class="pb-0">
              <v-carousel cycle hide-delimiters :show-arrows="false" height="300" interval="4000" vertical>
                <v-carousel-item v-for="(item, i) in demoImages" :key="i" :src="require(`@/assets/${item}.svg`)" />
              </v-carousel>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-col cols="7">
        <v-row align="space-between" no-gutters>
          <span class="d-block text--secondary subtitle-1 font-weight-medium">Comienza a recibir pagos</span>
          <v-spacer />
          <v-btn href="https://www.piriod.com/payment-links" target="_blank" color="primary" text :ripple="false">Más información<v-icon right small>mdi-open-in-new</v-icon></v-btn>
        </v-row>
        <v-divider />
        <v-row>
          <v-col>
            <v-avatar class="mb-2" color="indigo" size="36"><span class="white--text subtitle-1">1</span></v-avatar>
            <span class="d-block text--secondary subtitle-1 font-weight-medium">Crea un enlace</span>
            <span class="d-block mt-2 body-2">Vende productos o servicios, recibe donaciones o reservas fácilmente. Personalízalo con la marca y colores de tu empresa para que se ajuste al estilo de tu marca.</span>
          </v-col>
          <v-col>
            <v-avatar class="mb-2" color="indigo" size="36"><span class="white--text subtitle-1">2</span></v-avatar>
            <span class="d-block text--secondary subtitle-1 font-weight-medium">Comparte el enlace</span>
            <span class="d-block mt-2 body-2">Pega o inserta el enlace en tu sitio web, redes sociales o donde quieras. Puedes compartir el mismo enlace de pago con varios clientes y utilizarlo a través de múltiples canales.</span>
          </v-col>
          <v-col>
            <v-avatar class="mb-2" color="indigo" size="36"><span class="white--text subtitle-1">3</span></v-avatar>
            <span class="d-block text--secondary subtitle-1 font-weight-medium">Recibe los pagos</span>
            <span class="d-block mt-2 body-2">Ofrece múltiples métodos de pago a tus clientes y recibe los pagos desde los procesadores de pagos que ya tienes conectados en Piriod.</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="5">
        <v-row align="space-between" no-gutters>
          <span class="d-block text--secondary subtitle-1 font-weight-medium">Precios</span>
          <v-spacer />
          <v-btn @click="intercomNewMessage('Hola, me interesa saber más sobre los enlaces de pago')" class="ml-1" color="primary" text :ripple="false">Contactar a ventas<v-icon right small>mdi-chat</v-icon></v-btn>
        </v-row>
        <v-divider />
        <v-row align="space-between">
          <v-col cols="6" v-for="p in product" :key="`price-${p.id}`">
            <v-sheet class="px-4" height="190" rounded>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">{{ p.name }}<v-chip v-if="p.isCommingSoon" class="mx-3 mt-n1" color="defaultGrey" text-color="secondary" x-small>Próximamente</v-chip></v-list-item-title>
                  <v-list-item-subtitle class="text--secondary font-weight-medium">
                    <template v-if="p.prices[account.country.id]">
                      {{ p.prices[account.country.id].price }} {{ p.prices[account.country.id].currency }}
                    </template>
                    <template v-else>
                      {{ p.prices.global.price }} {{ p.prices.global.currency }}
                    </template>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
              <span class="d-block py-3 body-2 text--primary font-weight-regular">{{ p.description }}</span>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
    </template>
    <!-- end feature landing page -->

    <template v-else>
      <v-col cols="4" v-for="d in linksList" :key="d.id">
        <v-card class="card-apps" :to="{ name: 'LinkRetrieve', params: { id: d.id } }">
          <v-card-text class="py-6 px-0">
            <v-list class="transparent">
              <v-list-item>
                <v-list-item-icon>
                  <img :src="require(`@/assets/appIcon-apps--PaymentLinks.svg`)" width="24px">
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1 text--secondary font-weight-medium">{{ d.name || 'Sin nombre' }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <!-- fixed price -->
                    <template v-if="d.amount_scheme === 'fixed'">
                      <span class="py-2">{{ d.amount | currency(d.currency) }} {{ d.currency }}</span>
                    </template>
                    <!-- end fixed price -->

                    <!-- custom price -->
                    <template v-else-if="d.amount_scheme === 'custom'">
                      <span class="mt-1 font-italic text--disabled">Los clientes eligen que pagar</span>
                    </template>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="card-apps background" :to="{name: 'LinkCreate'}" outlined>
          <v-card-text class="py-11 text-center subtitle-1 primary--text font-weight-medium">Crear un nuevo Link</v-card-text>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { paymentLinks } from '../../../collections/products'

import ListViewMixin from '@/mixins/ListViewMixin'

import PiriodBetaLabel from '@/components/ux/PiriodBetaLabel'

export default {
  components: {
    PiriodBetaLabel
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    demoImages: [
      'appImage-customer-base--1',
      'appImage-customer-base--2',
      'appImage-customer-base--3'
    ],
    product: paymentLinks
  }),
  computed: mapState({
    linksList: state => state.apps.linksList
  }),
  methods: {
    getList () {
      this.$store.dispatch('apps/LIST', {
        resource: 'payment_links/links'
      })
    }
  }
}
</script>
<style scoped>
  .component-hero {
    background-image: url('../../../assets/appBg-links--hero.svg');
    background-size: cover;
  }
</style>